import {AVAILABILITY_STATE, AvailabilityStore} from '../slices/AvailabilityStateSlice';

export const isAvailabilityEnabledSelector = (store: AvailabilityStore): boolean => {
  return store[AVAILABILITY_STATE]?.isEnabled ?? false;
};
